import { createSlice } from "@reduxjs/toolkit";
import { getDashboardData } from "../Thunk/dashboardThunk";

const initialState = {
  stats: {},
  chartData: [],
  approvals: [],
  pendingProviders: [],
  pendingProviderCount: 0,
  approvedProviderCount: 0,
  rejectedProviderCount: 0,
  pendingPrescriptionCount: 0,
  s3CorsHealth: null,
  activity: [],
  loading: false,
  error: null,
};

const dashboardSlice = createSlice({
  name: "dashboard",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getDashboardData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getDashboardData.fulfilled, (state, action) => {
        state.loading = false;
        state.stats = action.payload?.stats || {};
        state.chartData = action.payload?.chartData || [];
        state.approvals = action.payload?.approvals || [];
        state.pendingProviders = action.payload?.pendingProviders || [];
        state.pendingProviderCount = action.payload?.pendingProviderCount ?? 0;
        state.approvedProviderCount = action.payload?.approvedProviderCount ?? 0;
        state.rejectedProviderCount = action.payload?.rejectedProviderCount ?? 0;
        state.pendingPrescriptionCount = action.payload?.pendingPrescriptionCount ?? 0;
        state.s3CorsHealth = action.payload?.s3CorsHealth || null;
        state.activity = action.payload?.activity || [];
      })
      .addCase(getDashboardData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Something went wrong";
      });
  },
});

export default dashboardSlice.reducer;
